import {
    InputRenderAction,
    InputRenderEntry
} from "../../../Reducers/Client/InputRender/InputRenderReducer"
import { ClientType } from "../../Types"
import { JSONSchema7 } from "json-schema"
import { validate } from "../../../Helpers/Schema/Schema"

export const changeInputValueWithValidation = (
    id: string,
    values: any,
    schema: JSONSchema7 | undefined,
    surviveReroute?: boolean
) =>
    changeInputValue(id, {
        values,
        surviveReroute,
        errors:
            schema === undefined ? [] : validate(schema, values).errors || []
    })

export const changeInputValue = (id: string, data: InputRenderEntry) => {
    const action: InputRenderAction = {
        type: ClientType.inputRender_change,
        payload: data,
        meta: { id }
    }

    return action
}

export const clearInputsForId = (id: string) => {
    const action: InputRenderAction = {
        type: ClientType.inputRender_clear,
        payload: id
    }

    return action
}

export const dirtinessChanged = (isDirty: boolean): InputRenderAction => ({
    type: ClientType.inputRender_dirtinessChanged,
    payload: isDirty
})

export const setVisualOnboarding = (
    isVisualOnboarding: boolean
): InputRenderAction => ({
    type: ClientType.inputRender_setVisualOnboarding,
    payload: isVisualOnboarding
})
